import React from 'react';
import noop from 'lodash/noop';
import Button from '../button';
import { Size } from '../_util/enum';
const Operation = props => {
    const { moveToLeft = noop, moveToRight = noop, leftArrowText = '', rightArrowText = '', leftActive, rightActive, className, } = props;
    return (React.createElement("div", { className: className },
        React.createElement(Button, { type: "primary", size: Size.small, disabled: !leftActive, onClick: moveToLeft, icon: "keyboard_arrow_left" }, leftArrowText),
        React.createElement(Button, { type: "primary", size: Size.small, disabled: !rightActive, onClick: moveToRight, icon: "keyboard_arrow_right" }, rightArrowText)));
};
export default Operation;
